import { useState } from "react";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

const inquiryOptions = [
  "General Inquiry",
  "Program Information",
  "Partnership / Sponsorship",
  "Volunteer Opportunity",
  "Donation Interest",
  "Press / Media",
];

export const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    inquiry: "General Inquiry",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in your name, email, and message.");
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      toast("This is unavailable at the moment. Please check back soon.", {
        description:
          "In the meantime, reach us at ydevelopment7@gmail.com or 424-610-7795.",
      });
      setSubmitting(false);
    }, 600);
  };

  return (
    <form
      onSubmit={handleSubmit}
      data-testid="contact-form"
      className="grid grid-cols-1 md:grid-cols-2 gap-5"
      noValidate
    >
      <div>
        <label className="tag mb-2 block" htmlFor="cf-name">
          Full Name
        </label>
        <input
          id="cf-name"
          name="name"
          type="text"
          value={form.name}
          onChange={handleChange}
          placeholder="Your full name"
          className="dc-field"
          data-testid="contact-input-name"
          required
        />
      </div>
      <div>
        <label className="tag mb-2 block" htmlFor="cf-email">
          Email
        </label>
        <input
          id="cf-email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          placeholder="you@example.com"
          className="dc-field"
          data-testid="contact-input-email"
          required
        />
      </div>
      <div>
        <label className="tag mb-2 block" htmlFor="cf-phone">
          Phone (optional)
        </label>
        <input
          id="cf-phone"
          name="phone"
          type="tel"
          value={form.phone}
          onChange={handleChange}
          placeholder="(424) 555-0100"
          className="dc-field"
          data-testid="contact-input-phone"
        />
      </div>
      <div>
        <label className="tag mb-2 block" htmlFor="cf-inquiry">
          Inquiry Type
        </label>
        <select
          id="cf-inquiry"
          name="inquiry"
          value={form.inquiry}
          onChange={handleChange}
          className="dc-field"
          data-testid="contact-input-inquiry"
        >
          {inquiryOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
      <div className="md:col-span-2">
        <label className="tag mb-2 block" htmlFor="cf-message">
          Message
        </label>
        <textarea
          id="cf-message"
          name="message"
          rows={5}
          value={form.message}
          onChange={handleChange}
          placeholder="Tell us how we can serve, partner, or pray with you."
          className="dc-field resize-none"
          data-testid="contact-input-message"
          required
        />
      </div>
      <div className="md:col-span-2 mt-2 flex flex-col sm:flex-row sm:items-center gap-5">
        <button
          type="submit"
          className="btn-base btn-ink"
          data-testid="contact-submit-button"
          disabled={submitting}
        >
          {submitting ? "Sending…" : "Send Message"}
          <ArrowUpRight size={14} />
        </button>
        <p className="font-mono text-[11px] tracking-[0.16em] text-[#0E0E0E]/70">
          OR EMAIL{" "}
          <a
            href="mailto:ydevelopment7@gmail.com"
            className="text-[#FF5A1F] hover:underline"
            data-testid="contact-direct-email"
          >
            ydevelopment7@gmail.com
          </a>
          {" · "}CALL{" "}
          <a
            href="tel:+14246107795"
            className="text-[#FF5A1F] hover:underline"
            data-testid="contact-direct-phone"
          >
            424-610-7795
          </a>
        </p>
      </div>
    </form>
  );
};

export default ContactForm;
